module.exports = __webpack_public_path__ + "img/TAZEEM PHOTO - SAE ZHCET (1) (1).86ca8268.jpg";